import { SET_AUTHED_USER, UPDATE_PROFILE, ACCEPT_REGULATIONS } from '../actions/authedUser'

export default function authedUser (state = null, action) {
	switch (action.type) {
		case SET_AUTHED_USER :
			return action.authedUser === null
				? null
				: {
					...state,
					...action.authedUser
				}

		case UPDATE_PROFILE :
			return {
        ...state,
        ...action.user
			}

		case ACCEPT_REGULATIONS :
			return {
        ...state,
        statuteAccepted: 1
			}

		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/authedUser.js